<template>
  <pc-modal-wrapper class="otp">
    <pc-modal-container :show-close="showClose" @close="$emit('close')">
      <div class="pc-modal__form">
        <div class="pc-modal__content">
          <h3 class="text-center">
            <slot name="title"></slot>
          </h3>
          <div class="pc-verification-modal-input__wrap">
            <div class="pc-verification-modal-input">
              <template>
                <input
                  v-for="(_, idx) in Array(totalNumbers)"
                  ref="inputs"
                  :key="idx"
                  :value="numbers[idx]"
                  maxlength="1"
                  type="number"
                  :class="{'disabled':showResend || !!blockSeconds}"
                  :disabled="showResend || !!blockSeconds"
                  @keyup.delete="numberDeletePrev($event.data, idx)"
                  @input="numberInput($event.data, idx)"
                />
                <input-error v-if="error" class="pc-verification-modal-input__error">
                  {{ $t(error) }}
                </input-error>
              </template>
            </div>
          </div>
          <div v-if="!hideCountdown" class="try-info">
            <div class="try-info__time-left">
              {{ $t('verification-modal.time-left-short') }} {{ remainingSecondsText }}
            </div>
            <div class="try-info__tries-left">
              {{ $t('verification-modal.tries-left-short') }} {{ tries }}
            </div>
          </div>
          <!--          <template v-if="isDocSign && showDocSignResend">-->
          <!--            <input-error class="pc-verification-modal-input__error doc-sign">-->
          <!--              {{ $t('common.code-expired') }}-->
          <!--            </input-error>-->
          <!--          </template>-->
        </div>
        <div class="pc-modal__actions">
          <pc-button v-if="isBlocked">
            {{ remainingTimeUIText }}
          </pc-button>
          <template v-else-if="showResend">
            <pc-button :disabled="false" @click="resendCode">
              {{ $t('verification-modal.resend-code') }}
            </pc-button>
          </template>
          <template v-else>
            <pc-button
              :disabled="!isAllNumbersFilled"
              @click="emitConfirmation"
            >
              <template v-if="showLoader">
                <icu-icon class="pc-big-loader"></icu-icon>
              </template>
              <template v-else>
                {{ $t('verification-modal.confirm') }}
              </template>
            </pc-button>
          </template>
        </div>
        <template v-if="showContacts">
          <div class="pc-verification-modal__contacts">
            {{ $t(contactsText) }}
          </div>
          <icu-contacts
            view-type="horizontal"
            :show-phone="isResident"
            :email-to="emailTo"
          />
        </template>
      </div>
    </pc-modal-container>
  </pc-modal-wrapper>
</template>

<script>
import ModalWrapper from '@/components/modals/ModalWrapper.vue'
import ModalContainer from '@/components/modals/ModalContainer.vue'
import IcuButton from '@/components/common/IcuButton.vue'
import { every, fill } from 'lodash'
import InputError from '@/components/inputs/InputError.vue'
import IcuContacts from '@/components/common/IcuContacts'
import PcModalWrapper from '@/components/modals/PcModalWrapper'
import PcModalContainer from '@/components/modals/PcModalContainer'
import PcTextInput from '@/components/inputs/PcTextInput'
import PcButton from '@/components/common/PcButton'
import IcuIcon from '@/components/common/IcuIcon.vue'

export default {
  name: 'PcVerificationModal',
  components: {
    IcuIcon,
    PcButton,
    PcTextInput,
    PcModalContainer, PcModalWrapper, IcuContacts, InputError, IcuButton, ModalContainer, ModalWrapper },
  props: {
    type:{
      type: String,
      default: ''
    },
    showClose: {
      type: Boolean,
      default: true
    },
    totalNumbers: {
      type: Number,
      default: 4
    },
    emailTo: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    blockTime: {
      type: Number,
      default: 0
    },
    liveTime: {
      type: Number,
      default: 0
    },
    isDocSign: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: ''
    },
    triesLeft: {
      type: Number,
      default: 0
    },
    isResident: {
      type: Boolean,
      default: true
    },
     showContacts: {
      type: Boolean,
       default: true
     },
    hideCountdown: {
      type: Boolean,
      default: true
    },
    showLoader: {
      type: Boolean,
      default: false
    }

  },
  blockTimer: null,
  liveTimer: null,
  data() {
    return {
      numbers: [],
      blockSeconds: 0,
      liveSeconds: null,
      deletePrevFlag: true,
      tries: this.triesLeft
    }
  },
  computed: {
    showResend(){
      if(this.hideCountdown){
        return !!this.blockTime && !this.blockSeconds
      }

      return !this.liveSeconds || !this.tries
    },
    isBlocked(){
      return !!this.blockSeconds
    },
    contactsText() {
      const phoneSuf = this.isResident? '-with-phone': ''
      return this.type==='phone'? `notifications.sms-code-send-fail-text${phoneSuf}`: `notifications.code-send-fail-text${phoneSuf}`
    },
    remainingTimeUIText() {
      const seconds = this.blockSeconds % 60
      const minutes = Math.floor(this.blockSeconds / 60) % 60
      const hours = Math.floor(this.blockSeconds / 3600)

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
    remainingSecondsText() {
      const seconds = this.liveSeconds % 60
      const minutes = Math.floor(this.liveSeconds / 60) % 60

      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
    isAllNumbersFilled() {
      return every(this.numbers, number => !!number)
    },

  },
  watch: {
    blockTime:{
      handler: function(newVal){
        if(newVal) {
          clearInterval(this.$options.blockTimer)
          if (newVal) {
            this.blockSeconds = newVal
            this.$options.blockTimer = setInterval(this.timer, 1000)
          } else {
            this.$options.blockTimer = null

          }
        }
      },
      immediate: true
    },
    liveTime:{
      handler: function(newVal){
        if(newVal) {
          clearInterval(this.$options.liveTimer)
          if (newVal) {
            this.liveSeconds = newVal
            this.$options.liveTimer = setInterval(this.liveTimer, 1000)
          } else {
            this.$options.liveTimer = null

          }
        }
      },
      immediate: true
    }
    ,
    liveSeconds(newVal) {
      if(!newVal) {
        this.tries = 0
      }
    },
    triesLeft(newVal, oldVal){
      this.tries = newVal
      if(!newVal) {
        clearInterval(this.$options.liveTimer)
        this.liveSeconds = 0
      }
    }
  },
  beforeMount() {
    this.resetInput()
  },
  methods: {
    resetInput() {
      this.numbers = fill(Array(this.totalNumbers), null)
    },
    timer() {
      if (this.blockSeconds >= 1) {
        this.blockSeconds--
      } else {
        clearInterval(this.$options.blockTimer)
        this.blockSeconds = null
      }
    },
    liveTimer() {
      if (this.liveSeconds >= 1) {
        this.liveSeconds--
      } else {
        clearInterval(this.$options.liveTimer)
        this.liveSeconds = null
      }
    },
    resendCode() {
      this.resetInput()
      this.$emit('resend')
    },
    numberInput(value, inputIdx) {
      const curInput = this.$refs.inputs[inputIdx]
      const val = curInput.value ? curInput.value.replace(/[^0-9]/g,'') : curInput.value
      if(val) {
        if (val.length > 1) {
          const valArr = val.split('')
          let index = 0
          for ( let i = inputIdx; i <= 3; i++) {
            if(valArr[index]) {
              this.$set(this.numbers, i, valArr[index])
              this.$refs.inputs[i].focus()
            }
            index ++
          }
        } else {
          this.$set(this.numbers, inputIdx, val)
          if (val && inputIdx < this.totalNumbers - 1) {
            this.$refs.inputs[inputIdx].nextElementSibling.focus()
          }
        }
      } else {
        curInput.value = ''
        this.deletePrevFlag = false
        this.$set(this.numbers, inputIdx, null)
      }
    },
    numberDeletePrev(value, idx) {
      if(this.deletePrevFlag) {
        if (this.numbers[idx]) {
          this.$set(this.numbers, idx, value)
        } else {
          if (idx > 0) {
            this.$set(this.numbers, idx - 1, undefined)
            this.$refs.inputs[idx].previousElementSibling.focus()
          }
        }
      }
      this.deletePrevFlag = true
    },
    emitConfirmation() {
      this.$emit('confirm', this.numbers.join(''))
    }
  }

}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/components/modals/PcVerificationModal.scss";

.pc-pc-verification-modal {
  display: flex;
  flex-direction: column;
  align-items: center;

  & * {
    text-align: center;
  }
}
.pc-pc-verification-modal-input__error.doc-sign {
  text-align: center;
  font-size: 16px;
  padding: 76px 0 30px;
  position: static;
  transform: none;
}
.disabled {
  opacity: 0.7;
}
.try-info {
  padding-bottom: 0px;
  align-self: center;

  span {
    color: $active-green;
    font-weight: 600;
  }

  &__time-left, &__tries-left{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 10px !important;
    line-height: 14px;
    color: $error-text !important;
  }

}
.otp {
  z-index: 9000;
}



</style>
